import TechStackScroller from "../components/TechStackScroller";
import ExpertiseStatsSection from "../components/ExpertiseStatsSection";
import ExperienceSection from "../components/ExperienceSection";

export default function About() {
  return (
    <section
      id="expertise"
      className="w-full bg-light dark:bg-dark text-black dark:text-white py-24"
    >
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex items-baseline gap-4 mb-6">
          <span className="font-mono text-[13px] text-accent">01</span>
          <h2 className="text-3xl font-bold tracking-tight">Expertise</h2>
          <span className="flex-1 h-px bg-black/10 dark:bg-white/10" />
        </div>
        <p className="text-lg text-muted dark:text-pale max-w-2xl mb-4">
          Hard-working, self-motivated professional with nearly two decades in the
          construction and building-controls industry.
        </p>
      </div>

      <ExpertiseStatsSection />

      <div className="w-full max-w-5xl mx-auto">
        <TechStackScroller />
      </div>

      <ExperienceSection />
    </section>
  );
}
